export const fr = {
  deliveryPickUpTime: "Heure de collecte",
  deliveryTargetTime: "Heure de livraison",
  from: "De",
  to: "À",
  status: "Statut",
  actions: "Actions",
  auth: {
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    email: "E-mail",
    password: "Mot de passe",
    login: "Se connecter",
    signup: "S'inscrire",
    logout: "Se déconnecter",
    loginDescription: "Bienvenue ! Connectez-vous pour gérer vos envois et transports.",
    loggingIn: "Connexion en cours...",
    continueWithGoogle: "Continuer avec Google",
    or: "OU",
    noAccount: "Pas encore de compte ?",
    signUp: "S'inscrire",
    backToHome: "Retour à la page d'accueil",
    createAccount: "Créer un compte",
    createAccountDesc: "Inscrivez-vous et commencez à envoyer des colis",
    creatingAccount: "Création du compte en cours...",
    confirmPassword: "Confirmer le mot de passe",
    passwordHelper: "Doit contenir au moins 6 caractères",
    acceptTerms: "J'accepte les ",
      termsOfService: "conditions d'utilisation",
      organizationInvite: "Invitation à une organisation",
      inviteMessage: "Vous avez été invité à rejoindre l'organisation suivante :",
      loadingOrganizationInfo: "Chargement des informations de l'organisation...",
      accountCreationFailed: "La création du compte a échoué.",
    error: {
      passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
      loginFailed: "La connexion a échoué",
      unknownError: "Erreur inattendue. Veuillez réessayer.",
      googleLoginFailed: "La connexion avec Google a échoué",
      organizationInfoNotFound: "Informations de l'organisation introuvables",
      organizationInfoFetchFailed: "La récupération des informations de l'organisation a échoué",
      emailRequired: "L'adresse e-mail est requise",
      invalidEmail: "L'adresse e-mail n'est pas valide",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      acceptTerms: "Vous devez accepter les conditions d'utilisation",
      accountCreationFailed: "La création du compte a échoué",
    }
  },
  header: {
    appName: "PH",
    activity: "Livraisons",
    sendPackage: "Envoyer",
    deliverPackage: "Transporter",
    carry: "Transporter",
    organisation: "Organisation",
    payments: "Paiements",
    profile: "Profil",
    myDeliveries: "Mes transports",
    settings: "Paramètres",
    logout: "Se déconnecter",
    login: "Se connecter",
    signup: "S'inscrire",
    info: "Info",
  },
  delivery: {
    courier: "Coursier",
    segments: "segments",
    routeSteps: "Étapes du transport",
    changeBusOption: "Changer l'option de bus",
    busStep: "Segment bus",
    waitStep: "Correspondance bus",
    carStep: "Segment voiture",
    busRoute: "Itinéraire de bus",
    car: "Voiture",
    carDesc: "Livraison directe par coursier en voiture",
    publicTransport: "Transport public",
    publicTransportDesc: "Livraison en bus ou en train",
    selectAddressesToSeeOptions: "Sélectionnez les adresses pour voir les options de livraison",
    noOptionsAvailable: "Aucune option de livraison disponible pour cet itinéraire",
    selectBasicOption: "Sélectionner une option de livraison standard",
    selectFastOption: "Sélectionner une option de livraison rapide",
    notSet: "Non défini",

    // bus
    updateBusSchedule: "Mettre à jour l'horaire de bus",
    // emballage
    needPackaging: "Avez-vous besoin de matériel d'emballage ?",
    packagingUpsell: "Commandez des matériaux d'emballage pour vos produits à prix réduit.",

    // Section facturation
    billingInfo: "Informations de facturation",

    paymentMethod: "Mode de paiement",
    invoice: "Facture",
    invoiceDescription: "Payer plus tard par facture",
    card: "Carte",
    cardDescription: "Payer immédiatement par carte",
    yNumber: "Numéro d'entreprise",
    yNumberHelper: "Optionnel - Numéro d'entreprise finnois",
    companyName: "Nom de l'entreprise",
    companyNamePlaceholder: "Entreprise SARL",
    companyNameHelper: "Optionnel",
    paymentReference: "Référence de paiement",
    paymentReferencePlaceholder: "Numéro de référence ou code projet",
    paymentReferenceHelper: "Optionnel - pour le suivi interne",
    billingDepartment: "Centre de coût",
    billingDepartmentPlaceholder: "Nom du département ou centre de coût",
    billingDepartmentHelper: "Optionnel",
    cardPaymentNote:
      "Le paiement sera traité après l'envoi de la livraison. Vous serez redirigé vers la page de paiement.",

    payNow: "Payer maintenant",
    payForDelivery: "Payer la livraison",
    paymentRequired: "Paiement requis",
    paymentSuccessful: "Paiement réussi !",
    paymentFailed: "Paiement échoué. Veuillez réessayer.",
    noOptionsSelected: "Aucune option spéciale sélectionnée",

    selectOptions: "Sélectionner des options supplémentaires",
    billingAndOptions: "Facturation et options supplémentaires",
    "eco-bus": "Colis bus",
    "eco-regular": "Colis standard",

    timing: "Heure de collecte et de livraison",
    locations: "Lieu de collecte et de livraison",
    people: "Expéditeur et destinataire",
    returnParcel: "Lien de retour",
    prePaid: "Prépayé",
    packageInfo: "Informations du colis",
    billing: "Facturation",
    total: "Total",
    sender: "Expéditeur",
    recipient: "Destinataire",
    delivery: "Livraison",
    reviewDelivery: "Vérifier l'envoi",
    reviewDescription: "Vérifiez que les informations d'envoi sont correctes",
    confirmAndPay: "Confirmer et envoyer",
    packageCategory: "Catégorie de taille",
    selectItems: "Sélectionner les articles",
    selectPackageItems: "Définition de l'envoi",
    items: "articles",
    kg: "kg",
    route: "Itinéraire",
    origin: "Point de départ",
    destination: "Destination",
    originHelp: "Lieu de collecte de votre colis",
    labelsInfo:
      "Imprimez les étiquettes d'expédition et collez-les sur les colis avant la collecte.",
    selectProductsForLabels: "Sélectionnez le colis pour lequel vous souhaitez imprimer des étiquettes",
    printLabelsSubtitle: "Sélectionnez un colis et imprimez les étiquettes d'adresse",
    printLabels: "Imprimer les étiquettes",
    pickupNow: "Disponible immédiatement",
    pickupDate: "Date de collecte",
    today: "Aujourd'hui",
    tomorrow: "Demain",

    pickupTimeModal: {
      title: "Heure de collecte",
      time: "Heure de collecte",
    },
    express: "Livraison express",
    expressDesc: "Livraison la plus rapide disponible",
    ecoBus: "Colis bus",
    fast: "Rapide",
    fastDesc: "Service de livraison rapide",
    eco: "Éco",
    ecoDesc: "Option la moins chère - livraison flexible",

    standard: "1-5 jours",
    custom: "Personnalisé",
    any: "Pas de préférence horaire pour la livraison",
    from: "Point de départ",
    to: "Destination",
    bustransport: "Transport par bus",
    noDeliveries: "Pas encore de transport",
    printWaybill: "Imprimer la lettre de voiture",
    resend: "Renvoyer",
    waybillPrinted: "Lettre de voiture téléchargée avec succès",

    status: {
      active: "Actif",
      ongoing: "Coursier trouvé",
      accepted: "Accepté",
      picked: "Collecté",
      completed: "Terminé",
      cancelled: "Annulé",
    },

    // Titre de page
    sendPackage: "Envoyer",
    deliverPackage: "Transporter",

    // Champs de lieu
    pickup: "Collecte",
    dropoff: "Livraison",

    // Taille du colis
    selectPackageSize: "Sélectionner la taille",
    size: "Taille",
    small: "Petit (0–20 kg)",
    medium: "Moyen (20–30 kg)",
    large: "Grand (30–90 kg)",
    xl: "Très grand (90+ kg)",

    // Poids
    weight: "Poids (kg)",

    // Informations
    moreDetails: "Plus de détails",
    detailsTitle: "📋 Informations supplémentaires",

    // Distance et durée
    distance: "Distance (km)",
    duration: "Durée (min)",
    distanceWithDuration: " km • min",

    // Boutons et actions
    createDelivery: "Continuer",
    createDeliveryWithPrice: "Créer un envoi • {{price}}€",
    create: "Créer",
    creating: "Création en cours...",
    creatingDelivery: "Création en cours...",

    // Estimation
    estimate: "Estimation",
    estimatedPrice: "Prix estimé",

    // Options de livraison
    deliveryOptions: "Options de livraison",
    calculatingRates: "Calcul des tarifs...",
    enterAddressesPrompt:
      "Entrez les adresses de collecte et de livraison pour voir les options",

    // Types de livraison principaux
    startingFrom: "À partir de",
    earliestDelivery: "Livraison au plus tôt",

    // Types d'options (existants)
    busparcel: "Colis bus",
    busparcelDesc: "Colis bus - cliquez pour sélectionner",
    customDesc: "Définissez votre propre prix",
    customPriceLabel: "Prix personnalisé (€)",

    "eco-bus": "Colis bus",

    // Menu Éco
    selectEcoOption: "Sélectionner le mode de transport",
    busTransport: "Transport par bus",
    busTransportDesc: "Livraison via le réseau de transport public",
    regular: "Standard",
    regularDesc: "Livraison de colis ordinaire",
    bid: "Offre",
    bidDesc: "Définissez votre propre prix - non garanti",

    // Livraison standard
    regularOptions: "Options de livraison standard",
    pickupLocation: "Collecte",
    deliveryLocation: "Livraison",
    parcelCenter: "Point colis",
    homePickup: "Collecte à domicile",
    homeDelivery: "Livraison à domicile",
    free: "Gratuit",
    totalPrice: "Prix total",

    // Offre
    bidTitle: "Définissez votre offre",
    bidWarning:
      "Attention : adaptez votre offre au délai de livraison et à la distance. Une offre trop basse peut entraîner l'absence de coursier pour votre livraison.",
    yourPrice: "Votre prix",
    priceLabel: "Prix (€)",
    pickupTime: "Disponible à partir de",
    latestPickupTime: "Collecte au plus tard",
    latestPickUpHelp: "Optionnel : définissez l'heure de collecte maximale",
    targetTime: "Livré au plus tard",
    earliestTargetTime: "Livrable au plus tôt",
    earliestPickupTime: "Collecte disponible au plus tôt",
    latestPickup: "Collecte au plus tard",
    latestTargetTime: "À livrer au plus tard",
    hideTimeWindow: "Annuler la définition",
    setTimeWindow: "Préciser la fenêtre horaire",
    date: "Date",
    time: "Heure de collecte et de livraison",

    // Options spéciales
    specialOptions: "Options spéciales",
    returnParcels: "Retour de colis",
    returnMethod: "Mode de retour",
    returnByBus: "Bus",
    returnByPost: "Poste",
    returnParcelsDesc: "L'envoi revient à l'expéditeur après livraison",
    temperatureControl: "Contrôle de température",
    temperatureControlDesc: "Nécessite un suivi de température",
    canBeLeftAtDoor: "Livraison sans contact",
    canBeLeftAtDoorDesc: "Le colis peut être laissé à la porte du destinataire",
    requiresPin: "Code PIN requis",
    requiresPinDesc: "Le destinataire doit fournir un code PIN pour recevoir l'envoi",
    requiresSignature: "Signature requise",
    requiresSignatureDesc: "Le destinataire doit signer la réception de l'envoi",

    // Mes livraisons
    sendNew: "Créer un envoi",
    myDeliveries: "Mes envois",
    resendNotification:
      "Informations de transport chargées. Mettez à jour et créez un nouveau transport.",

    // Sections collecte et livraison
    pickupDetails: "Détails de collecte",
    deliveryDetails: "Détails de livraison",
    addressDetails: "Détails de l'adresse",
    optional: "(Optionnel)",
    senderInformation: "Informations de l'expéditeur",
    recipientInformation: "Informations du destinataire",
    notSelected: "Non sélectionné",

    // Heure
    timeWindow: "Heure",
    target: "Heure cible",
    timeWindowPriceNote: "La définition d'une plage horaire ajoute 4€ + TVA",

    // TVA
    vat: "TVA incluse",

    // Expéditeur/Destinataire
    senderName: "Nom de l'expéditeur",
    senderPhone: "Numéro de téléphone de l'expéditeur",
    senderEmail: "Adresse e-mail de l'expéditeur",
    recipientName: "Nom du destinataire",
    recipientPhone: "Numéro de téléphone du destinataire",
    recipientEmail: "Adresse e-mail du destinataire",

    editDetailsDescription: "Modifier les informations",
    selected: "Sélectionné",
    printSelected: "Enregistrer les lettres de voiture",
    price: "Prix",
    company: "Entreprise",

    // Champs du formulaire
    form: {
      apartmentNumber: "Numéro d'appartement",
      apartmentPlaceholder: "ex. 12B",
      floor: "Étage",
      floorPlaceholder: "ex. 3e étage",
      buildingName: "Nom du bâtiment",
      buildingPlaceholder: "ex. Bâtiment A",
      accessCode: "Code d'accès",
      accessCodePlaceholder: "ex. #1234*",
      pickupInstructions: "Instructions de collecte",
      pickupInstructionsPlaceholder:
        "Déposer le colis à la réception, sonner deux fois, etc.",
      deliveryInstructions: "Instructions de livraison",
      deliveryInstructionsPlaceholder: "Laisser à la porte, appeler à l'arrivée, etc.",
      name: "Nom",
      senderNamePlaceholder: "Nom de l'expéditeur",
      recipientNamePlaceholder: "Nom du destinataire",
      phone: "Numéro de téléphone",
      phonePlaceholder: "+33 6 12 34 56 78",
      email: "E-mail",
      emailPlaceholder: "exemple@email.com",
    },

    // Messages d'erreur
    errors: {
      selectAddresses: "Veuillez sélectionner les adresses de collecte et de livraison.",
      selectOption: "Veuillez sélectionner une option de livraison.",
      createFailed: "La création du transport a échoué.",
      waybillPrintFailed: "Échec de l'impression de la lettre de voiture.",
    },

    // Messages de succès
    success: {
      created: "Envoi créé avec succès !",
    },

    // Catégories de taille
    small: "Petit colis",
    medium: "Taille moyenne",
    large: "Grand",
    extraLarge: "Très grand",

    // Caractéristiques techniques
    specifications: "Caractéristiques techniques",
    maxDimensions: "Dimensions maximales",

    // Articles
    items: "Articles",
    item: "Article",
    addItem: "Ajouter un article",

    // Dimensions
    length: "Longueur (cm)",
    width: "Largeur (cm)",
    height: "Hauteur (cm)",

    // Descriptions des tailles
    sizeDescriptions: {
      small: {
        example: "Facile à porter à la main",
        description: "Lettres, documents, petits colis",
      },
      medium: {
        example: "Rentre dans le coffre d'une voiture",
        description: "Boîtes de taille moyenne, équipements sportifs",
      },
      large: {
        example: "Rentre dans un véhicule utilitaire",
        description: "Grandes boîtes, meubles",
      },
      extraLarge: {
        example: "Nécessite un camion",
        description: "Électroménager, grands meubles",
      },
    },

    busTransportModal: {
      // Heure
      timePickerHint: "Vous pouvez trouver une heure de départ qui vous convient.",
      waitTime: "Temps d'attente à l'arrêt de bus",
      title: "Colis bus",
      departureTime: "Heure de départ",
      deliveryOptions: "Options de livraison",
      includeFirstMile: "Collecte à domicile jusqu'à l'arrêt de bus",
      includeLastMile: "Livraison de l'arrêt de bus au destinataire",

      // Avertissements
      bothSelfService:
        "Vous devez déposer le colis à la gare de départ et le destinataire doit le récupérer à la gare d'arrivée.",
      firstMileSelfService: "Vous devez déposer le colis à la gare de départ vous-même.",
      lastMileSelfService:
        "Le destinataire doit récupérer le colis à la gare d'arrivée.",

      // Titres des étapes
      selfService: "Soi-même",
      selfTransport: "Transport personnel",
      carTransport: "Transport en voiture",
      busTrip: "Trajet en bus",
      busSegment: "Bus",
      carSegment: "Voiture",

      // Infos sur l'itinéraire
      route: "Itinéraire",
      from: "Point de départ",
      to: "Destination",
      distance: "Distance",
      duration: "Durée",
      steps: "étapes",
      busChange: "Correspondance",
      busTransport: "Transport par bus",
      availableOptions: "Options disponibles",
      noOptions: "Aucune option de bus disponible pour cet itinéraire.",

      // Résumé
      price: "Prix",
      routeSteps: "Étapes de l'itinéraire",
      priceBreakdown: "Détail du prix",
      departure: "Départ",
      arrival: "Arrivée",
      specifications: "Informations",

      // Actions
      select: "Sélectionner le colis bus",
      selectTime: "Sélectionner l'heure",

      // Erreurs
      fetchError: "Impossible de récupérer les connexions de bus",
      generalError: "Erreur lors de la récupération des options de bus",

      // bus
      showRoute: "Afficher l'itinéraire",
      hideRoute: "Masquer l'itinéraire",
      customRoute: "Modifier l'itinéraire",
      editable: "Modifiable",
      invalidRoute: "L'itinéraire n'est pas valide",
      addStepAtStart: "Ajouter une étape au début",
      addStepAfter: "Ajouter une étape",
      editRoute: "Modifier l'itinéraire",
      addStep: "Ajouter une étape",
      editStep: "Modifier l'étape",
      editBusChange: "Modifier la correspondance",
      waitTimeMinutes: "Temps d'attente (min)",
      routeNumber: "Numéro de ligne",
      company: "Compagnie",
      firstMile: "Collecte",
      lastMile: "Livraison",
      firstMileDesc: "Transport du domicile à la gare routière",
      busSegmentDesc: "Trajet en bus entre deux gares",
      busChangeDesc: "Temps d'attente à la gare",
      lastMileDesc: "Transport de la gare routière au destinataire",
      noAvailableSteps: "Aucune étape à ajouter",
    },
  },

  payment: {
    completePayment: "Effectuer le paiement",
    amountToPay: "Montant à payer",
    enterPaymentDetails: "Choisissez un mode de paiement et entrez vos informations",
    enterCardDetails: "Saisissez les informations de votre carte",
    choosePaymentMethod: "Choisissez votre mode de paiement",
    cardTitle: "Carte",
    cardDescription: "Payez par carte bancaire en toute sécurité avec Stripe",
    cryptoTitle: "Cryptomonnaie",
    cryptoMethodDescription: "Choisissez une cryptomonnaie et payez avec NOWPayments",
    cryptoDescription: "Vous serez redirigé vers NOWPayments pour choisir une cryptomonnaie et effectuer le paiement.",
    continueToCryptoPayment: "Continuer vers le paiement crypto",
    reopenCryptoPayment: "Rouvrir la page de paiement",
    cryptoWaiting: "En attente du paiement…",
    cryptoConfirming: "En attente de la confirmation de la blockchain…",
    cryptoConfirmed: "Paiement confirmé !",
    cryptoExpired: "Ce paiement a expiré. Veuillez recommencer.",
    cryptoFailed: "Le paiement a échoué. Veuillez réessayer.",
    payAmount: "Payer {{amount}} €",
    initializationFailed: "Échec de l'initialisation du paiement",
    processingPayment: "Traitement du paiement en cours...",
  },

  terms: {
    title: "Conditions de vente",
    lastUpdated: "Dernière mise à jour",
    footer: {
      rights: "Tous droits réservés.",
      payment: "Paiement",
      withdrawal: "Droit de rétractation",
      returns: "Retours",
      complaints: "Réclamations",
    },
  },

  processing: "Traitement en cours...",

  filters: {
    all: "Tout",
    location: "Emplacement",
    category: "Catégorie",
    subcategory: "Sous-catégorie",
    sort: "Tri",
    price: "Prix",
  },

  common: {
    apply: "Terminé",
    reset: "Annuler",
    done: "Terminé",
    total: "Total",
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    confirm: "Sélectionner",
    back: "Retour",
    next: "Suivant",
    submit: "Continuer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
  },

  user: {
    title: "Mon Compte",
    subtitle:
      "Gérez vos informations personnelles, la facturation et les paramètres de l'organisation",
    loading: "Chargement du compte...",
    tabs: {
      profile: "Profil",
      billing: "Facturation",
      organization: "Organisation",
    },
  },

  profile: {
    title: "Mon Profil",
    subtitle: "Gérez vos informations personnelles et les paramètres de votre compte",
    loading: "Chargement du profil...",
    editButton: "Modifier le profil",
    saveButton: "Enregistrer les modifications",
    cancelButton: "Annuler",
    updateSuccess: "Profil mis à jour avec succès",
    updateError: "Échec de la mise à jour du profil. Veuillez réessayer.",

    fields: {
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Adresse e-mail",
      phone: "Numéro de téléphone",
      phonePlaceholder: "+33 6 12 34 56 78",
      mode: "Mode utilisateur",
      optional: "Optionnel",
    },

    mode: {
      none: "Non sélectionné",
      sender: "Expéditeur",
      courier: "Coursier",
    },

    validation: {
      firstNameRequired: "Le prénom est obligatoire",
      lastNameRequired: "Le nom de famille est obligatoire",
      emailRequired: "L'e-mail est obligatoire",
      invalidEmail: "Veuillez entrer une adresse e-mail valide",
      invalidPhone: "Veuillez entrer un numéro de téléphone valide",
    },

    accountInfo: {
      title: "Informations du compte",
      userId: "Identifiant utilisateur",
      postalCode: "Code postal",
      notSet: "Non défini",
      roles: "Rôles",
    },
  },

  billing: {
    title: "Informations de facturation",
    subtitle: "Gérez les informations de l'entreprise pour la facturation",
    editButton: "Modifier les informations de facturation",
    saveButton: "Enregistrer les modifications",
    cancelButton: "Annuler",
    updateSuccess: "Informations de facturation mises à jour avec succès",
    updateError: "Échec de la mise à jour des informations de facturation. Veuillez réessayer.",

    billingInfo: {
      title: "Informations de facturation",
    },

    paymentInfo: {
      title: "Informations de paiement",
      subtitle: "Informations pour recevoir les rémunérations des livraisons",
    },

    fields: {
      yNumber: "Numéro d'entreprise",
      companyName: "Nom de l'entreprise",
      billingMethod: "Mode de facturation",
      billingFrequency: "Fréquence de facturation",
      billingFrequencyHelp: "Période de facturation fixe",
      paymentYNumber: "Numéro d'entreprise du bénéficiaire",
      paymentCompanyName: "Nom de l'entreprise",
      iban: "IBAN",
    },

    billingMethod: {
      invoice: "Facture",
      card: "Carte",
    },

    validation: {
      yNumberRequired: "Le numéro d'entreprise est requis",
      companyNameRequired: "Le nom de l'entreprise est requis",
      paymentYNumberRequired: "Le numéro d'entreprise de paiement est requis",
      paymentCompanyNameRequired: "Le nom de l'entreprise de paiement est requis",
      ibanRequired: "L'IBAN est requis",
      invalidIban: "Format IBAN invalide",
    },

    summary: {
      title: "Résumé de la facturation",
      billingEntity: "Entité facturée",
      billingMethod: "Mode de facturation",
      paymentEntity: "Bénéficiaire du paiement",
      billingFrequency: "Fréquence de facturation",
      every7Days: "Tous les 7 jours",
    },
  },

  organization: {
    tabs: {
      info: "Informations",
      deliveries: "Livraisons",
    },
    title: "Organisation",
    subtitle: "Gérez votre organisation et les membres de l'équipe",
    editButton: "Modifier l'organisation",
    createButton: "Créer une organisation",
    saveButton: "Enregistrer les modifications",
    createAndSaveButton: "Créer l'organisation",
    cancelButton: "Annuler",
    updateSuccess: "Organisation mise à jour avec succès",
    updateError: "Échec de la mise à jour de l'organisation. Veuillez réessayer.",

    noOrganization: "Aucune organisation",
    createPrompt: "Créez une organisation pour gérer les membres",
    memberView: "Membre",
    readOnlyNotice: "Seul le propriétaire de l'organisation peut modifier ces informations",
    inviteLinkCopied: "Lien d'invitation copié dans le presse-papiers",
    copyFailed: "Échec de la copie du lien d'invitation",
    memberRemoved: "Membre supprimé avec succès",
    removeMemberError: "Échec de la suppression du membre",

    member: "membre",
    members: "membres",

    fields: {
      name: "Nom de l'organisation",
      organizationName: "Nom de l'organisation",
      organizationNamePlaceholder: "Votre organisation",
      description: "Description",
      descriptionPlaceholder: "Décrivez ce que fait votre organisation...",
      email: "E-mail",
      phone: "Téléphone",
      postalCode: "Code postal",
      locationPostalCode: "Code postal de l'emplacement",
      locationAddress: "Adresse",
      address: "Adresse",
      addressPlaceholder: "Adresse postale",
      optional: "Optionnel",
    },

    location: {
      title: "Emplacement",
      subtitle: "Informations d'emplacement optionnelles de l'organisation",
    },

    validation: {
      nameRequired: "Le nom de l'organisation est obligatoire",
    },

    roles: {
      owner: "Propriétaire",
      admin: "Administrateur",
      member: "Membre",
    },

    invite: {
      title: "Inviter des membres",
      description: "Partagez ce lien pour inviter des utilisateurs dans votre organisation",
      copy: "Copier le lien d'invitation",
      copied: "Copié !",
    },

    members: {
      title: "Membres",
      description: "Gérez les membres de l'organisation",
      unnamed: "Membre sans nom",
      you: "Vous",
      remove: "Supprimer le membre",
      copyUid: "Copier l'UID",
      uidCopied: "UID copié dans le presse-papiers",
      addButton: "Ajouter un membre",
      table: {
        name: "Nom",
        email: "E-mail",
        phone: "Téléphone",
        actions: "Actions",
      },
      removeDialog: {
        title: "Supprimer le membre",
        description: "Êtes-vous sûr de vouloir supprimer {{name}} de l'organisation ?",
        confirm: "Supprimer",
        cancel: "Annuler",
      },
    },

    addMember: {
      title: "Ajouter un utilisateur existant",
      description: "Ajoutez un utilisateur qui a déjà un compte en entrant son identifiant (UID)",
      uidPlaceholder: "Entrez l'UID de l'utilisateur...",
      helperText: "Vous pouvez trouver l'UID de l'utilisateur dans son profil ou ses paramètres de compte",
      button: "Ajouter un membre",
      uidRequired: "L'identifiant utilisateur est obligatoire",
      alreadyMember: "L'utilisateur est déjà membre de l'organisation",
      success: "Membre ajouté avec succès",
      error: "Échec de l'ajout du membre. Vérifiez l'UID et réessayez.",
    },

    deleteDialog: {
      title: "Supprimer le membre de l'équipe",
      description: "Êtes-vous sûr de vouloir supprimer {{name}} de l'organisation ?",
      cancel: "Annuler",
      confirm: "Supprimer",
    },

    info: {
      title: "Informations de l'organisation",
      name: "Nom",
      description: "Description",
      members: "Membres",
      location: "Emplacement",
    },

    deliveries: {
      title: "Livraisons de l'organisation",
      subtitle: "Consultez et gérez toutes les livraisons effectuées par votre organisation",
      ownerOnly: "Seuls les propriétaires de l'organisation peuvent consulter les livraisons",
      membersOnly: "Seuls les membres de l'organisation peuvent consulter les livraisons",
      loadError: "Échec du chargement des livraisons",
      noDeliveries: "Pas encore de livraisons",
      noResults: "Aucune livraison ne correspond à votre recherche",
      search: "Rechercher par identifiant, expéditeur, coursier ou lieu...",
      sortBy: "Trier par",
      order: "Ordre",
      export: "Exporter en CSV",
      rowsPerPage: "Lignes par page",
      stats: {
        total: "Total des livraisons",
        revenue: "Revenus totaux",
        couriers: "Coursiers uniques",
      },
      sortOptions: {
        date: "Date",
        price: "Prix",
        sender: "Expéditeur",
        courier: "Coursier",
      },
      orderOptions: {
        asc: "Croissant",
        desc: "Décroissant",
      },
      table: {
        id: "Identifiant de livraison",
        date: "Effectuée le",
        sender: "Expéditeur",
        courier: "Coursier",
        route: "Itinéraire",
        price: "Prix",
        reward: "Rémunération",
      },
    },
  },

  drive: {
    transportModal: {
      title: "Sélectionner le mode de transport",
      options: {
        all: "Tout",
        wait: "Correspondance bus",
        express: "Voiture particulière",
        van: "Camionnette",
      },
    },
    locationModal: {
      title: "Mettre à jour la localisation",
      description: "Les livraisons sont filtrées en fonction de votre localisation.",
      label: "Ville ou adresse",
      placeholder: "par ex. Helsinki",
      currentLocation: "Votre localisation",
      locating: "Recherche de la localisation…",
      useCurrentLocation: "Utiliser la localisation actuelle",
    },
    reportProblem: {
      title: "Signaler un problème",
      description: "Sélectionnez le type de problème et ajoutez des détails si nécessaire.",
      detailsLabel: "Informations complémentaires (facultatif)",
      detailsPlaceholder: "Décrivez ce qui s'est passé…",
      revertLabel: "Annuler la livraison et la libérer pour les autres",
      revertDescription: "À utiliser si vous ne pouvez pas terminer la livraison",
      revertWarning: "La livraison sera remise au statut Disponible. Une raison valable est requise, sinon des frais d'annulation peuvent s'appliquer.",
      urgentHelp: "En cas d'urgence, appelez le +358 50 505 8167",
      submitting: "Envoi en cours…",
      submit: "Envoyer le signalement",
      revertAndSubmit: "Annuler et envoyer le signalement",
      issues: {
        not_found: "Je ne trouve pas le colis",
        address_wrong: "L'adresse est incorrecte",
        recipient_unreachable: "Le destinataire est injoignable",
        package_damaged: "Le colis est endommagé",
        bus_issue: "Problème avec le transport en bus",
        other: "Autre",
      },
    },
  },

  downloadApp: {
    title: "Application Pakettihuolto",
    subtitle: "L'application coursier pour téléphones Android",
    download: "Télécharger l'application",
    preparing: "Préparation du téléchargement…",
    versionInfo: "Version {{version}} · Android 8.0 ou plus récent",
    stepsTitle: "Premiers pas",
    unknownSources: "Si l'installation ne démarre pas, autorisez les installations depuis des sources inconnues dans les paramètres de votre téléphone pour l'application avec laquelle vous avez ouvert le fichier (généralement Chrome ou Fichiers).",
    support: "Problème d'installation ? Contactez tuki@pakettihuolto.fi",
    error: {
      urlFailed: "Impossible de récupérer le lien de téléchargement. Veuillez réessayer dans un instant.",
    },
    notice: {
      ios: "L'application fonctionne uniquement sur les téléphones Android. Sur iPhone, utilisez pakettihuolto.fi dans votre navigateur.",
      desktop: "Ouvrez cette page sur votre téléphone Android pour installer l'application.",
    },
    steps: {
      download: {
        title: "Télécharger l'application",
        body: "Appuyez sur le bouton de téléchargement ci-dessus pour obtenir le fichier APK.",
      },
      install: {
        title: "Ouvrir le fichier et appuyer sur Installer",
        body: "Ouvrez le fichier APK téléchargé depuis vos notifications ou l'application Fichiers. Quand Android demande si vous souhaitez installer l'application, appuyez sur Installer.",
      },
      playProtect: {
        title: "Autoriser l'installation si Play Protect affiche un avertissement",
        body: "Comme l'application ne vient pas de Google Play, un avertissement peut apparaître. Appuyez sur \"Plus de détails\", puis sur \"Installer quand même\" pour continuer.",
      },
      login: {
        title: "Se connecter",
        body: "Utilisez les mêmes identifiants que sur pakettihuolto.fi.",
      },
      deliveries: {
        title: "Voir vos livraisons",
        body: "Les livraisons qui vous sont attribuées apparaissent dans l'onglet Lobby.",
      },
    },
  },
};
